import { mediaQueries } from './mediaQueries';
import { useMatchMedia } from './useMatchMedia';

export function useScreenSm(): boolean {
  return useMatchMedia(mediaQueries.screens.sm);
}
